import React from "react";

import * as CHQ from "chq";

import CheerList from "./cheers/CheerList";

type CheerToggle = (
  _entityId: number,
  _cheerForUser: null | CHQ.Cheer,
  _cheersCount: number
) => void;

type CommentCheersProps = {
  comment: CHQ.Cheerable<CHQ.Comment>;
  onCheerToggle?: CheerToggle;
};

export const CommentCheers: React.FC<CommentCheersProps> = ({ comment, onCheerToggle }) => (
  <CheerList
    entity={comment}
    cheersPath={`/comments/${comment.id}/cheers`}
    onCheerToggle={onCheerToggle}
    small
  />
);

type PhotoCheersProps = {
  photo: CHQ.Cheerable<CHQ.Photo>;
  onCheerToggle?: CheerToggle;
};

export const PhotoCheers: React.FC<PhotoCheersProps> = ({ photo, onCheerToggle }) => (
  <CheerList
    entity={photo}
    cheersPath={`/photos/${photo.id}/cheers`}
    onCheerToggle={onCheerToggle}
  />
);

type StoryCheersProps = {
  story: CHQ.Cheerable<CHQ.Story>;
  onCheerToggle?: CheerToggle;
};

export const StoryCheer: React.FC<StoryCheersProps> = ({ story, onCheerToggle }) => (
  <CheerList
    entity={story}
    cheersPath={`/stories/${story.id}/cheers`}
    onCheerToggle={onCheerToggle}
  />
);

type RecognitionCheersProps = {
  recognition: CHQ.Cheerable<CHQ.Recognition>;
  onCheerToggle?: CheerToggle;
};

export const RecognitionCheers: React.FC<RecognitionCheersProps> = ({
  recognition, onCheerToggle
}) => (
  <CheerList
    entity={recognition}
    cheersPath={`/recognitions/${recognition.id}/cheers`}
    onCheerToggle={onCheerToggle}
  />
);

type UserActivityCheersProps = {
  userActivity: CHQ.Cheerable<CHQ.UserActivity>;
  onCheerToggle?: CheerToggle;
};

export const UserActivityCheers: React.FC<UserActivityCheersProps> = ({
  userActivity, onCheerToggle
}) => (
  <CheerList
    entity={userActivity}
    cheersPath={`/user_activities/${userActivity.id}/cheers`}
    onCheerToggle={onCheerToggle}
  />
);
